import { render } from "./MyMatches.vue?vue&type=template&id=00bebcb0&ts=true"
import script from "./MyMatches.vue?vue&type=script&lang=ts"
export * from "./MyMatches.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__